/* 布局 */
//前台
import Layout from "@views/layout";

const reservationashreturnRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "reservationashreturn/list",
        name: "RESERVATIONASHRETURN",
        meta: {
            title: "骨灰返送地点管理",
            keepAlive:true
        },
        component: () => import("@views/business/reservationashreturn/index.vue"),
    },
        ],
};

export default reservationashreturnRouter;
